<style lang="stylus" scoped>
@import '../cardMap.stylus';

.title {
  span {
    margin: 0px 15px;
    border-bottom: 3px solid transparent;
    color: #999999;
    display: inline-block;
    height: auto;
    line-height: 2;
  }

  span.active {
    border-color: #336CAF;
    color: #326DAF;
  }
}

.mark {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  display: flex;
  background: rgba(0, 0, 0, 0.7);
  z-index: 100;

  .circle {
    margin: auto;
  }
}

.map-search .map-title {
  padding-bottom: 20px;
  margin-bottom: 16px;
  height: auto;
  border-radius: 5px;
}

.map-data {
  border-radius: 5px;
  margin-bottom: 20px;
}

.title {
  span {
    margin: 0px 15px;
    border-bottom: 3px solid transparent;
    color: #999999;
    display: inline-block;
    height: auto;
    line-height: 2;
  }

  span.active {
    border-color: #336CAF;
    color: #326DAF;
  }
}

.mark {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  display: flex;
  background: rgba(0, 0, 0, 0.7);
  z-index: 100;

  .circle {
    margin: auto;
  }
}

.map-search .map-title {
  padding-bottom: 20px;
  margin-bottom: 16px;
  height: auto;
  border-radius: 5px;
}

.map-data {
  border-radius: 5px;
  margin-bottom: 20px;
}
</style>
<template>
  <div class="home-main">
    <div class="mark" v-if="mark">
      <el-progress type="circle" :percentage="progressNum" class="circle" style="color:#fff;"></el-progress>
    </div>
    <div class="map-search" v-loading="loading">
      <div class="map-title">
        <el-row>
          <el-col :span="12">
            <Times :changeType="changeType" :tab="datatype"/>
            <div style="line-height:30px;margin-left:-10px;font-size:14px;">
              <span class="color2 pointer" @click="goCountry">全国</span>>
              <span class="color2 pointer" @click="goProvince">{{provinceName}}</span>>
              <span>{{cityName}}</span>
            </div>
          </el-col>
          <el-col :span="12">
            <div class="t-r" style="padding-top:55px;line-height:50px;">
              <el-date-picker
                :clearable="false"
                v-model="timeSection"
                value-format="timestamp"
                type="daterange"
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                @change="change"
              ></el-date-picker>
              <br>
              <!--  -->
              <el-button v-show="hideExport" style="margin-left:20px;" @click="exportDate">导出</el-button>
              
              <SearchBtn/>
              <el-button style="margin-left:20px;" @click="goProvince">返回上级</el-button>
            </div>
          </el-col>
        </el-row>
      </div>
    </div>
    <!-- <TableDate :dataAll="total" :loading="loading"/> -->
    <template v-for="item in tableDatas">
      <TableDate
        :dataAll="item"
        :name="item.name"
        :key="item.name"
        :code="item.code"
        :loading="loading"
      />
    </template>
  </div>
</template>
<script>
import SearchBtn from '../components/searchBtn' //跳转到搜索页
import Times from '../components/header' //快速选择时间
import TableDate from '../components/tableDate' //表格数据
import http from '@/api/consump.js' //请求汇总
import Cookies from 'js-cookie'
import { hideExport } from '@/utils/tools'
export default {
  data() {
    return {
      hideExport:hideExport,
      mark: false, //遮罩层开关
      timeSection: [
        new Date(new Date() * 1 - 3 * 24 * 3600 * 1000) * 1,
        new Date(new Date() * 1 - 0 * 24 * 3600 * 1000) * 1
      ],
      progressNum: 0, //下载进度条进度
      provinceName: null,
      cityName: null,
      cityCode: null,
      tableDatas: [],
      total: {},
      datatype: '1', //快速选择时间类型
      loading: true, //加载动画
      provinceCode1: null //真实省份code
    }
  },
  created() {
    this.provinceName = decodeURIComponent(this.$route.query.provinceName)
    this.cityName = decodeURIComponent(this.$route.query.cityName)
    this.provinceCode = decodeURIComponent(this.$route.query.cityCode)
    this.timeSection = JSON.parse(this.$route.query.times)
    this.provinceCode1 = decodeURIComponent(this.$route.query.provinceCode)
    this.cityCode = decodeURIComponent(this.$route.query.cityCode)
    this.datatype = this.$route.query.timeTab + '' // 默认时间
  },
  mounted() {
    let that = this
    that.init()
  },
  // watch: {
  //   timeSection: function(value, oldValue) {
  //     this.init()
  //     this.datatype = '1'
  //   }
  // },
  methods: {
    goCountry() {
      let that = this
      this.$router.push({
        name: 'consumpRegion',
        query: {
          times: JSON.stringify(that.timeSection),
          timeTab: that.datatype //时间类型
        }
      })
    },
    goProvince() {
      let that = this
      this.$router.push({
        name: 'consumpProvince',
        query: {
          times: JSON.stringify(that.timeSection),
          provinceName: that.provinceName,
          provinceCode: that.provinceCode1,
          timeTab: that.datatype //时间类型
        }
      })
      //this.$router.go(-1)
    },
    change() {
      let that = this
      that.loading = true
      http
        .allCity({
          section: that.timeSection,
          cityCode: this.provinceCode,
          type: that.datatype
        })
        .then(e => {
          that.total = { ...e.data }
        })
      that.initSity()
      this.datatype = '1'
    },
    exportDate() {
      //导出 ExportSity
      let that = this
      that.mark = true
      let reqId = Cookies.get('user')
      let times
      times = setInterval(function() {
        http.progress({ reqId }).then(e => {
          that.progressNum = e.data.percent
          if (e.data.percent >= 100) {
            that.mark = false
            that.progressNum = 0
            clearInterval(times)
          }
        })
      }, 100)
      reqId += new Date() * 1
      window.location.assign(
        http.ExportSity({
          start: that.timeSection[0],
          end: that.timeSection[1],
          cityCode: that.cityCode,
          reqId
        })
      )
    },
    goBack(num) {
      this.$router.go(num)
    },
    init() {
      // let that = this
      // that.loading = true
      // http
      //   .allCity({
      //     section: that.timeSection,
      //     cityCode: this.provinceCode,
      //     type: that.datatype
      //   })
      //   .then(e => {
      //     that.total = { ...e.data }
      //     that.timeSection = e.data.timeSection.split(',').map(e => e * 1)
      //   })
      this.initSity()
    },
    initSity() {
      let that = this
      http
        .allSity({
          section: that.timeSection,
          type: that.datatype,
          cityCode: this.provinceCode
        })
        .then(e => {
          that.tableDatas = [...e.data]
          that.timeSection = e.timeSection.split(',').map(e => e * 1)
          that.loading = false
        })
    },
    changeType(type) {
      this.datatype = type
      this.init()
    }
  },
  components: {
    Times,
    SearchBtn,
    TableDate
  }
}
</script>
